export const REGISTRATION_USER_PENDING = "user/REGISTRATION_USER_PENDING";
export const REGISTRATION_USER_FULFILLED = "user/REGISTRATION_USER_FULFILLED";

export const LOGIN_USER_PENDING = "user/LOGIN_USER_PENDING";
export const LOGIN_USER_FULFILLED = "user/LOGIN_USER_FULFILLED";

export const LOGOUT_USER_PENDING = "user/LOGOUT_USER_PENDING";
export const LOGOUT_USER_FULFILLED = "user/LOGOUT_USER_FULFILLED";

export const GET_USER_PENDING = "user/GET_USER_PENDING";
export const GET_USER_FULFILLED = "user/GET_USER_FULFILLED";
export const GET_USER_ERROR = "user/GET_USER_ERROR";

export const UPDATE_USER_PENDING = "user/UPDATE_USER_PENDING";
export const UPDATE_USER_FULFILLED = "user/UPDATE_USER_FULFILLED";
